export default function Veranstaltungskalender() {
  const data = {
    title: "",
    year: 2026,
     content:[
        {
            "visible": true, 
            "date":"04.01.2026", 
            "event":" Gesang ins neue Jahr",
            "time":"10:00 UHR"
        },
        {
            "visible": true, "date":"23.01.2026",
            "event":"Kleine Geburtstagsrunde",
            "time":"19:00 UHR"
        },
        {
            "visible": true, "date":"16.02.2026",
            "event":"Jahreshauptversammlung für alle Mitglieder",
            "time":"19:00 UHR"
        },
        {
            "visible": true, "date":"04.04.2026",
            "event":"Brauchtumsfeuer / Osterfeuer auf der Engelwiese Opperode",
            "time":"18:00 UHR"
        },
        {
            "visible": true, "date":"11.04.2026",
            "event":"„Frühjahrsputz auf der Sängerplatte“",
            "time":""
        },
        {
            "visible": true, "date":"18.04.2026",
            "event":"„Frühjahrsputz auf der Sängerplatte“",
            "time":""
        },
        {
            "visible": true, "date":"16.05.2026",
            "event":"Singen zum Schnitterfest- Meisdorf",
            "time":"13:00 UHR"
        },
        {
            "visible": true, "date":"24.05.2026",
            "event":"Pfingstsingen Am Stahlsberg",
            "time":"14:30 UHR"
        },
        {
            "visible": true, "date":"20.06.2026",
            "event":"Ausflug der Sänger zum Erlebnis Braugasthof Brauner Hirsch",
            "time":"09:30 UHR Sophienhof (max.55 Personen, begrenzt durch Bustransfer)",
        },
        {
            "visible": true, "date":"19.07.2026",
            "event":"Musik geht durch den Magen / Jägerschaft /Friedrichsbrunn",
            "time":"10:00 UHR Konzert der Bläser bis ca.14:00 UHR"
        },
        {
            "visible": true, "date":"01.08.2026", 
            "event":"Chor Harzgerode, Vereinsheim BMK-Sommerfest",
            "time":""
        },
        {
            "visible": true, "date":"15.08.2026", 
            "event":"Große Geburtstagsrunde mit Partner auf der Sängerplatte",
            "time":"17:00 UHR"
        },
        {
            "visible": true, "date":"05.09.2026", 
            "event":"Dorffest mit den Vereinen von Opperode Sängerplatte",
            "time":"15:00 UHR"
        },
        {
            "visible": true, "date":"26.09.2026", 
            "event":"Singen Erntedankfest Landfrauen Opperode ???",
            "time":"15:00 UHR"
        },
        {
            "visible": true, "date":"03.10.2026", 
            "event":"Singen zum Ernte- Dank- Fest- Westdorf ???",
            "time":"15:00 UHR"
        },
        {
            "visible": true, "date":"14.11.2026", 
            "event":"Stiftungsfest",
            "time":"18:00 UHR"
        },
        {
            "visible": true, "date":"21.11.2026", 
            "event":"Vorweihnachtlicher Markt MCO auf der Sängerplatte",
            "time":"17:00 UHR"
        },
        {
            "visible": true, "date":"28.11.2026", 
            "event":"Singen im Altersheim + Ballenstedter Weihnachtsmarkt",
        },
        {
            "visible": true, "date":"05.12.2026", 
            "event":"Singen Weihnachtsmarkt Landfrauen Opperode",
            "time":"15:00 UHR"
        },
        {
            "visible": true, "date":"24.12.2026", 
            "event":"Singen Heilig Abend, in der Opperöder- Kirche",
            "time":"15:00 UHR"

        }
    ]
  };

  const visibleEvents = data.content.filter((item) => item.visible);

  return (
    <div className="min-h-screen bg-gray-50 p-6 flex items-start justify-center">
      <div className="w-full max-w-4xl bg-white shadow-xl rounded-2xl p-6">
        <h1 className="text-2xl font-bold mb-6">
          {data.title} {data.year}
        </h1>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="p-3 font-semibold">Datum</th>
                <th className="p-3 font-semibold">Uhrzeit</th>
                <th className="p-3 font-semibold">Veranstaltung</th>
              </tr>
            </thead>
            <tbody>
              {visibleEvents.length > 0 ? (
                visibleEvents.map((item, index) => (
                  <tr
                    key={index}
                    className="border-t hover:bg-gray-50 transition-colors"
                  >
                    <td className="p-3">{item.date}</td>
                    <td className="p-3">{item.time}</td>
                    <td className="p-3">{item.event}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={3}
                    className="p-4 text-center text-gray-500"
                  >
                    Keine Veranstaltungen vorhanden
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
